import React from 'react'
import './Accounts.css'

function DivInfo({langLocal,title,data}) {
    return (
        <div className='one-user-info' dir={langLocal ==='ar'? "rtl":"ltr"} >
            <div className='two-flex' >
                <div className={` ${langLocal === 'ar'? "margin_left_10": "margin_right_15"} circle-div-info`} ></div>
                <span className='title-user-info' >{title}</span>
            </div>
            <span className={`${langLocal == 'ar' ? "textAlignRight margin_right_20" : "margin_left_25"} data-user-info`}>{data}</span>
        </div>
    )
}

export default DivInfo